module.exports = __webpack_public_path__ + "d65471f00ad8fee4f01e152d30aaa5d2.webp";